export default __webpack_public_path__ + "static/media/spellcheck.23de7454.svg";